import React, { PropsWithChildren } from 'react';
import { Grid } from '@mui/material';
import { sideBarStyles } from '../../constants/theme/styles/layout/sidebar';




export const SideBarContent = (props: PropsWithChildren<any>) => {
    const classes = sideBarStyles();
    return (
        <>
            <Grid className='sidebar-content' container item md={4} >
                <Grid item xs={12} >
                    <div className={`${classes.sideBar}`}>
                        {props.children}
                    </div>
                </Grid>
            </Grid>
        </>
    );
};